import React, { useState, useEffect, useRef, useCallback } from "react";
import DynamicTable from "../../../components/admin/Table";
import { useParams } from "react-router-dom";
import Modal from "../../../components/UI/Modal";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error"
import { userService } from "../../../services";

const Users = () => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [deleteUser, setDeleteUser] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError]=useState(false)
  const [errorMessage, setErrorMessage]= useState(null)
  const { subCat } = useParams();
  // Define your table columns.
  const columns = ["username", "email", subCat==="all"? "role":null];
  
  // Function to fetch data from the API.
  const fetchData = async (pageNumber) => {
    setLoading(true);
    try {
      let query = ``;
      if (subCat !== "all") {
        query = subCat === "admin" ? "?isAdmin=true" : "?isAdmin=false";
      }
let allUser= await userService.allUsers(query)
allUser=allUser.map(user=>{
  user={...user, role:user.isAdmin?"Admin":"User"}
  return user
})
setTableData(allUser)
      //   // Replace this URL with your actual API endpoint.
      //   const response = await fetch(`https://your-api.com/data?page=${pageNumber}`);
      //   const newData = await response.json();
      //setTableData(data);
      //   if (newData.length === 0) {
      //     setHasMore(false);
      //   } else {
      //     setTableData((prev) => [...prev, ...newData]);
      //   }
    } catch (error) {
      setError(true)
      console.error("Error fetching data:", error);
    }finally{ 
      setLoading(false);
      setPageLoading(false)
    }
    
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData(page);
  }, [subCat]);

  // Set up the Intersection Observer to detect when the last row is visible.
  const observer = useRef();
  const lastRowRef = useCallback(
    // (node) => {
    //   if (loading) return;
    //   if (observer.current) observer.current.disconnect();

    //   observer.current = new IntersectionObserver((entries) => {
    //     if (entries[0].isIntersecting && hasMore) {

    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchData(nextPage);
    //     }
    //   });
    //   if (node) observer.current.observe(node);
    // },
    [loading, hasMore, page]
  );

  //let message = ``;
  // Handlers for row deletion and editing.
  const handleDelete = async () => {
    const data = [...tableData];
    try {
      setError(false)
      setErrorMessage(null)
    const newData = data.filter((data) => data._id !== deleteUser._id);
    setTableData(newData);
    setShowModal(false); 
    await userService.deleteUser(deleteUser._id)
    } catch (error) {
      setTableData(data)
      setError(true)
      setErrorMessage({message:"Deleting Artiste", message:"delete this artiste"})
      setShowModal(false)
    }  
  };

  const handleShowModal = (user) => {
    setShowModal(true);
    setDeleteUser(user);
  };

  const handleClodeModal = () => {
    setShowModal(false);
  };
  const tableTitle = subCat === "all" ? `All Users` : subCat;
  const messageTitle=<p className="text-red-500">Comfirm User Removal</p>;
  const message=<p> Are you sure you want to remove this user:<span className="font-bold text-red-500"> {deleteUser?.username}</span>?. This action cannot be undone!</p>;

  if (error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={`Error ${ errorMessage?.title || "Getting Artistes"} `} message={`There is error while trying to ${errorMessage?.message || "fetch the artistes lists"}. Please check your internet contivities and refresh this page to try again`} />;

  return (
    <>
      {pageLoading ? (
      <div className="grid place-items-center min-h-[60vh]">  <Spinner /></div>
      ) : (
        <div className="p-4 bg-gray-300 mix-blend-multiply h-full min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">{tableTitle}</h1>
          <Modal
            title={messageTitle}
            message={message}
            isOpen={showModal}
            onClose={handleClodeModal}
            comfirmAction={handleDelete}
          />

          <div className="overflow-x-auto">
            <DynamicTable
              columns={columns}
              data={tableData}
              onDelete={handleShowModal}
              url={"-user"}
              //   lastRowRef={lastRowRef}
            />
          </div>
          {loading && (
            <div className="flex justify-center mt-4">
              <div
                className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"
                role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!hasMore && (
            <div className="text-center text-gray-500 mt-4">
              No more data to load.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Users;
